module.exports = __webpack_public_path__ + "static/media/16.aea07566.jpg";